const TRANSLATIONS = {
  "AUTH/EMAIL/INPUT/LABEL": "Email address",
  "AUTH/EMAIL/INPUT/PLACEHOLDER": "email@address.com",
  "AUTH/FIRST_NAME/INPUT/LABEL": "First name",
  "AUTH/FIRST_NAME/INPUT/PLACEHOLDER": "First name",
  "AUTH/LAST_NAME/INPUT/LABEL": "Last name",
  "AUTH/LAST_NAME/INPUT/PLACEHOLDER": "Last name",
  "AUTH/PAIR": "Pair",
  "AUTH/PAIR/SUBTITLE": "Enter the pairing code shown on your device to connect it to your account.",
  "AUTH/PAIR/TITLE": "Connect a new device",
  "AUTH/PAIRED": "Paired",
  "AUTH/PAIRING_CODE/INPUT/LABEL": "Pairing code",
  "AUTH/PAIRING_CODE/INPUT/PLACEHOLDER": "e.g. 4821",
  "AUTH/PASSWORD/INPUT/LABEL": "Password",
  "AUTH/PASSWORD/INPUT/PLACEHOLDER": "Password",
  "AUTH/SIGN_OUT": "Sign out",
  "AUTH/TV/CODE_HINT": "Enter the following code and login",
  "AUTH/TV/EASY_LOGIN_CTA": "Sign in with the QR code",
  "AUTH/TV/EASY_LOGIN_HINT": "Want to go the easy route?",
  "AUTH/TV/LOGIN_CTA": "Sign in with account details",
  "AUTH/TV/LOGIN_HINT": "Or sign in with your account",
  "AUTH/TV/URL_HINT": "Scan the QR code or go to",
  "CAR/CONNECTED": "Connected to car",
  "CAR/CONTINUE_WATCHING": "Continue Watching",
  "COMMON/BACK_TO_HOME": "Back to home",
  "COMMON/BACK_TO_TOP": "Back to top",
  "COMMON/BACK": "Back",
  "COMMON/BACK/CTA/HINT": "You can navigate to previous page by using the back button",
  "COMMON/BACK/CTA/LABEL": "Back",
  "COMMON/CANCEL": "Cancel",
  "COMMON/CLEAR": "Clear",
  "COMMON/CLOSE": "Close",
  "COMMON/CONFIRM": "Confirm",
  "COMMON/EPISODES": "Episodes",
  "COMMON/EPISODES/SINGLE": "Episode",
  "COMMON/LINEAR/SINGLE": "Linear",
  "COMMON/LIVE": "Live",
  "COMMON/LOGO_ACCESSIBILITY_LABEL": "Logo",
  "COMMON/LOGO/LABEL": "Logo",
  "COMMON/MORE_ACTIONS": "More actions",
  "COMMON/MORE_INFO": "More info",
  "COMMON/MORE_INFO/CTA/HINT": "More information about the {{type}} {{title}}",
  "COMMON/MOVIES": "Movies",
  "COMMON/MOVIES/SINGLE": "Movie",
  "COMMON/NAVIGATION/ACCESSIBILITY_LABEL": "Primary",
  "COMMON/NEXT/CTA/LABEL": "Next",
  "COMMON/OFF": "Off",
  "COMMON/OK": "OK",
  "COMMON/ON": "On",
  "COMMON/PERIOD/MONTH": "month",
  "COMMON/PERIOD/YEAR": "year",
  "COMMON/PREVIOUS/CTA/LABEL": "Previous",
  "COMMON/READ_MORE": "Read more",
  "COMMON/RETRY": "Retry",
  "COMMON/SERIES": "Series",
  "COMMON/SERIES/SINGLE": "Series",
  "COMMON/SHARE": "Share",
  "DATE/DAY_BEFORE_YESTERDAY": "Day before yesterday",
  "DATE/YESTERDAY": "Yesterday",
  "DATE/TODAY": "Today",
  "DATE/TOMORROW": "Tomorrow",
  "DATE/DAY_AFTER_TOMORROW": "Day after tomorrow",
  "DEBUG/TITLE": "Debug",
  "DETAIL/CATEGORIES/ACCESSIBILITY_LABEL": "Categories: {{categories}}",
  "DETAIL/TITLE/LABEL": "Title: {{title}}",
  "DETAIL/PAGE_CONTEXT": "{{appName}} platform. You are currently on the '{{title}}' {{contentType}} page.",
  "DETAIL/GENRE": "Genre: {{genre}}.",
  "DETAIL/DESCRIPTION": "Description",
  "DETAIL/PLAY": "Play",
  "DETAIL/PLAY/ACCESSIBILITY_LABEL": "Play: Press to start watching.",
  "DETAIL/PLAY/WHERE": "Choose where to play",
  "DETAIL/PLAY_ON_TV": "Play on TV",
  "DETAIL/PLAY_ON_DEVICE/TITLE": "Play on this device",
  "DETAIL/PLAY_ON_DEVICE/ACCESSIBILITY_LABEL": "Play on this device: Starts playback on this device.",
  "DETAIL/PLAY_ON_TV/ACCESSIBILITY_LABEL": "Play on TV: Starts playback on the connected TV.",
  "ERROR/TV_CONNECT/PLAY_ON_TV": "Could not start playback on the TV.",
  "DETAIL/PUBLISH_DATE/LABEL": "Publish date: {{date}}",
  "DETAIL/SEASON": "Season {{number}}",
  "DETAIL/TO_SERIES": "Go to series",
  "DETAIL/TRAILER": "Trailer",
  "DETAIL/TRAILER/ACCESSIBILITY_LABEL": "Trailer: Press to watch the trailer.",
  "DETAIL/PLAY_TRAILER": "Play trailer",
  "DETAIL/PLAY_TRAILER/ACCESSIBILITY_LABEL": "Play trailer: Press to watch the trailer.",
  "DETAIL/TRAILER_ON_TV": "Trailer on TV",
  "DETAIL/TRAILER_ON_TV/ACCESSIBILITY_LABEL": "Trailer on TV: Starts the trailer on the connected TV.",
  "DETAIL/WATCHLIST/ADD": "Add to Watchlist",
  "DETAIL/WATCHLIST/ADD/ACCESSIBILITY_LABEL": "Add to Watchlist: Press to add this to your watchlist.",
  "DETAIL/WATCHLIST/REMOVE": "Remove from Watchlist",
  "DETAIL/WATCHLIST/REMOVE/ACCESSIBILITY_LABEL": "Remove from Watchlist: Press to remove this from your watchlist.",
  "EPG/REMAINING_MINUTES": "{{minutes}}m left",
  "EPG_PAGE/CHANNELS_TITLE": "Channels",
  "EPG_PAGE/EMPTY_SUBTITLE": "Try another day or check back later.",
  "EPG_PAGE/EMPTY_TITLE": "No programs for this day",
  "ERROR/AUTH/INVALID_CREDENTIALS": "Invalid email or password.",
  "ERROR/AUTH/LOGIN_REQUIRED": "Please sign in to continue",
  "ERROR/AUTH/PAIR": "Could not pair device",
  "ERROR/AUTH/REGISTER": "Registration failed. This email may already be in use.",
  "ERROR/AUTH/SIGN_OUT": "Could not sign out",
  "ERROR/AUTH/SUBTITLE": "Please sign in to continue",
  "ERROR/AUTH/TITLE": "Authentication required",
  "ERROR/DETAIL_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/DETAIL_PAGE/TITLE": "We couldn't load this",
  "ERROR/DYNAMIC_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/DYNAMIC_PAGE/TITLE": "We couldn't load this",
  "ERROR/GENERIC/SUBTITLE": "Please try again",
  "ERROR/GENERIC/TITLE": "An error occurred",
  "ERROR/NO_CONNECTION/SUBTITLE": "Check your internet connection",
  "ERROR/NO_CONNECTION/TITLE": "No connection",
  "ERROR/TV_APP/UNSUPPORTED_DEVICE/SUBTITLE": "This version is for TV devices only. Install the mobile app on phones and tablets.",
  "ERROR/TV_APP/UNSUPPORTED_DEVICE/TITLE": "Not supported on this device",
  "ERROR/NOT_FOUND/CTA": "Back to home",
  "ERROR/NOT_FOUND/SUBTITLE": "The page you're looking for doesn't exist",
  "ERROR/NOT_FOUND/TITLE": "Not found",
  "ERROR/PLAYER_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/PLAYER_PAGE/TITLE": "We couldn't load this",
  "ERROR/PROFILE_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/PROFILE_PAGE/TITLE": "We couldn't load this",
  "ERROR/PROFILES_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/PROFILES_PAGE/TITLE": "We couldn't load this",
  "ERROR/PROFILE_CREATE": "We couldn't create this profile",
  "ERROR/PROFILE_UPDATE": "We couldn't update this profile",
  "ERROR/PROFILE_DELETE": "We couldn't delete this profile",
  "ERROR/SEARCH_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/SEARCH_PAGE/TITLE": "We couldn't load this",
  "ERROR/SUBSCRIPTION_OFFERS_PANEL/SUBTITLE": "Check your connection and try again",
  "ERROR/SUBSCRIPTION_OFFERS_PANEL/TITLE": "We couldn't load this",
  "ERROR/SUBSCRIPTION_OFFERS/ACTIVATING": "Failed to activate subscription offer",
  "ERROR/SUBSCRIPTION_OFFERS/CANCELLING": "Failed to cancel subscription offer",
  "ERROR/WATCHLIST_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/WATCHLIST_PAGE/TITLE": "We couldn't load this",
  "ERROR/EPG_PAGE/SUBTITLE": "Check your connection and try again",
  "ERROR/EPG_PAGE/TITLE": "We couldn't load this",
  "ERROR/WATCHLIST/TOGGLE": "Could not add or remove from watchlist",
  "FOOTER/ABOUT": "About us",
  "FOOTER/COOKIES_POLICY": "Cookie Policy",
  "FOOTER/COPYRIGHT": "All rights reserved",
  "FOOTER/HELP": "Help",
  "FOOTER/PRIVACY_POLICY": "Privacy Policy",
  "FOOTER/TERMS_OF_SERVICE": "Terms of Use",
  "INTRO/PAGE/SIGN_IN/CTA/LABEL": "Sign in",
  "INTRO/SIGN_IN/CTA/HINT": "Sign in to your account",
  "INTRO/SKIP": "Later",
  "INTRO/SKIP/CTA/HINT": "Skip the intro and go to the app",
  "INTRO/SUBTITLE": "Whether you're looking for customization with the highest wow factor, an out-of-the-box white label solution, or a combination of both, {{appName}} offers it all.",
  "INTRO/TITLE": "Deliver your video content to smart and connected TVs in no time",
  "INTRO/WELCOME_ANNOUNCEMENT": "Welcome to {{appName}}. {{title}}. {{subtitle}}",
  "LOGIN_PAGE/CTA/LABEL": "Sign in",
  "LOGIN_PAGE/HEADING": "Sign in",
  "LOGIN_PAGE/REGISTER_LINK": "Create an account",
  "LOGIN_PAGE/TITLE": "Sign in",
  "PLAYER/CAST_OFF/CTA/LABEL": "Stop casting",
  "PLAYER/CAST_ON/CTA/LABEL": "Start casting",
  "PLAYER/CURRENT_TIME/LABEL": "Current time: {{time}}",
  "PLAYER/DURATION/LABEL": "Total duration: {{duration}}",
  "PLAYER/FULLSCREEN_OFF/CTA/HINT": "Exit fullscreen mode",
  "PLAYER/FULLSCREEN_OFF/CTA/LABEL": "Exit fullscreen",
  "PLAYER/FULLSCREEN_ON/CTA/HINT": "Enter fullscreen mode",
  "PLAYER/FULLSCREEN_ON/CTA/LABEL": "Enter fullscreen",
  "PLAYER/PAUSE/CTA/HINT": "Pause playback",
  "PLAYER/PAUSE/CTA/LABEL": "Pause",
  "PLAYER/PIP_ENTER/CTA/HINT": "Enter picture-in-picture mode",
  "PLAYER/PIP_ENTER/CTA/LABEL": "Enter picture-in-picture",
  "PLAYER/PIP_EXIT/CTA/HINT": "Exit picture-in-picture mode",
  "PLAYER/PIP_EXIT/CTA/LABEL": "Exit picture-in-picture",
  "PLAYER/PLAY/CTA/HINT": "Start playback",
  "PLAYER/PLAY/CTA/LABEL": "Play",
  "PLAYER/SEEK/CTA/HINT": "Use left and right to seek. Press select to apply.",
  "PLAYER/SEEK/CTA/LABEL": "Seek",
  "PLAYER/SKIP/BACKWARD/CTA/HINT": "Skip backward by {{seconds}} seconds",
  "PLAYER/SKIP/BACKWARD/CTA/LABEL": "Skip backward",
  "PLAYER/SKIP/FORWARD/CTA/HINT": "Skip forward by {{seconds}} seconds",
  "PLAYER/SKIP/FORWARD/CTA/LABEL": "Skip forward",
  "PLAYER/SOUND/OFF": "Sound off",
  "PLAYER/SOUND/OFF/CTA/HINT": "Turn sound off",
  "PLAYER/SOUND/ON": "Sound on",
  "PLAYER/SOUND/ON/CTA/HINT": "Turn sound on",
  "PLAYER/SUBTITLES/BOTTOM_SHEET_HEADING": "Subtitles",
  "PLAYER/SUBTITLES/CTA/HINT": "Toggle subtitles",
  "PLAYER/SUBTITLES/CTA/LABEL": "Subtitles",
  "PLAYER/SUBTITLES/NO_TRACKS": "No subtitles available",
  "PLAYER/SUBTITLES/OFF": "Off",
  "PLAYER/SUBTITLES/PANEL_HEADING": "Subtitles",
  "PLAYER/SUBTITLES/TRACK": "Track {{uid}}",
  "PROFILE_PAGE/BUTTON_SIGN_IN_LABEL": "Sign in",
  "PROFILE_PAGE/BUTTON_SWITCH_PROFILE_LABEL": "Switch profile",
  "PROFILE_PAGE/NAV_SUBSCRIPTION_OFFERS_LABEL": "Subscription plans",
  "PROFILE/SUBSCRIPTION_OFFERS/CANCEL": "Cancel",
  "PROFILE/SUBSCRIPTION_OFFERS/SUBSCRIBE": "Subscribe",
  "PROFILE/SUBSCRIPTION_OFFERS/SUBTITLE": "No subscription plans available.",
  "PROFILE/TAB_LABEL": "Profile",
  "PROFILE/TITLE": "Who's going to watch?",
  "PROFILE/CREATE/TILE_LABEL": "Add profile",
  "PROFILE/CREATE/TITLE": "Create profile",
  "PROFILE/UPSERT/SUBTITLE": "Pick a color and enter a name",
  "PROFILE/CREATE/NAME/INPUT/LABEL": "Profile name",
  "PROFILE/CREATE/NAME/INPUT/PLACEHOLDER": "Name...",
  "PROFILE/CREATE/COLOUR/OPTION_ACCESSIBILITY_LABEL": "Colour {{index}}",
  "PROFILE/CREATE/SAVE": "Save",
  "PROFILE/EDIT/TITLE": "Edit profile",
  "PROFILE/EDIT/HINT": "Press and hold to edit this profile",
  "PROFILE/OPTIONS/EDIT": "Edit profile",
  "PROFILE/EDIT/DELETE": "Delete profile",
  "PROFILE/EDIT/DELETE_CONFIRM": "Delete {{name}}? This cannot be undone.",
  "PROFILE/GROUP/ACCOUNT": "Account",
  "PROFILE/GROUP/SETTINGS": "Settings",
  "REGISTER_PAGE/CTA/LABEL": "Create account",
  "REGISTER_PAGE/HEADING": "Create an account",
  "REGISTER_PAGE/SIGN_IN_LINK": "Already have an account? Sign in",
  "REGISTER_PAGE/TITLE": "Create account",
  "SEARCH/CONVERSATIONAL/DOWNLOAD": "Download",
  "SEARCH/CONVERSATIONAL/DOWNLOAD_FAILED": "Couldn't download the search model. Try again.",
  "SEARCH/CONVERSATIONAL/DOWNLOAD_PROGRESS": "Downloading model… {{percent}}%",
  "SEARCH/CONVERSATIONAL/DOWNLOAD_SIZE_PROMPT": "This will download an on-device model (~{{sizeMb}} MB). Continue?",
  "SEARCH/CONVERSATIONAL/LABEL": "Conversational Search",
  "SEARCH/CONVERSATIONAL/NOT_ON_WIFI": "Connect to Wi-Fi to download the search model.",
  "SEARCH/CONVERSATIONAL/OFFLINE": "Connect to the internet to download the search model.",
  "SEARCH/CONVERSATIONAL/UNAVAILABLE": "Not available on this device.",
  "SEARCH/INPUT/PLACEHOLDER": "What are you looking for?",
  "SEARCH/INPUT/CLEAR": "Clear search",
  "SEARCH/NO_RESULTS/SUBTITLE": "Try a different search",
  "SEARCH/NO_RESULTS/TITLE": "No results found",
  "SEARCH/RECENT/CLEAR_CONFIRM": "Clear your recent searches?",
  "SEARCH/RECENT/TITLE": "Recently searched",
  "SEARCH/RECOMMENDATIONS/TITLE": "People also searched for",
  "SEARCH/VOICE/LISTENING": "Listening",
  "SEARCH/VOICE/MIC_HINT": "Tap to search by voice",
  "SEARCH/VOICE/MIC_LABEL": "Voice search",
  "SEARCH/VOICE/MIC_UNAVAILABLE": "Voice search is not available on this device",
  "SEARCH/VOICE/NO_SPEECH": "No speech detected. Try again.",
  "SEARCH/VOICE/PERMISSION_DENIED": "Microphone access is required for voice search. Enable it in Settings.",
  "SEARCH/VOICE/PERMISSION_RESTRICTED": "Voice search is restricted on this device. Check Screen Time or device management settings.",
  "SEARCH/VOICE/RECOGNITION_FAILED": "Voice search failed. Try again.",
  "SEARCH/VOICE/SIRI_HINT": "Hold the Siri button on your remote to dictate a search query",
  "SEARCH/VOICE/STOP_HINT": "Tap to stop voice search",
  "SEARCH/VOICE/STOP_LISTENING": "Stop listening",
  "SEARCH_SETTINGS_PANEL/CONVERSATIONAL_SEARCH/HINT": "Find titles by describing what you want, not just by name.",
  "SEARCH_SETTINGS_PANEL/CONVERSATIONAL_SEARCH/LABEL": "Enable Conversational Search",
  "SEARCH_SETTINGS_PANEL/HISTORY_HINT": "Save titles you open from search so you can find them again quickly.",
  "SEARCH_SETTINGS_PANEL/HISTORY_LABEL": "Enable Search History",
  "SEARCH_SETTINGS_PANEL/TITLE": "Search",
  "SEASON_SELECTOR_MODAL/TITLE": "Choose a season",
  "SETTINGS/CURRENT_PROFILE/HINT": "Current profile: {{name}}",
  "SUBSCRIPTION_OFFERS_PANEL/HEADING": "Subscription plans",
  "SUBSCRIPTION_OFFERS/ACTIVATION/CONFIRM": "Confirm",
  "SUBSCRIPTION_OFFERS/ACTIVATION/COUPON/INPUT/PLACEHOLDER": "Coupon code (optional)",
  "SUBSCRIPTION_OFFERS/ACTIVATION/DESCRIPTION": "Your subscription to the {{title}} plan will be activated immediately. You can optionally enter a coupon code if you have one.",
  "SUBSCRIPTION_OFFERS/ACTIVATION/DOWNGRADE": "Downgrade",
  "SUBSCRIPTION_OFFERS/ACTIVATION/SUBSCRIBE": "Subscribe",
  "SUBSCRIPTION_OFFERS/ACTIVATION/TITLE": "Activate {{title}} plan",
  "SUBSCRIPTION_OFFERS/ACTIVATION/UPGRADE": "Upgrade",
  "SUBSCRIPTION_OFFERS/CANCELLATION/DESCRIPTION": "Are you sure you want to cancel your {{title}} subscription? You will lose access to all content after your billing cycle ends.",
  "SUBSCRIPTION_OFFERS/CANCELLATION/TITLE": "Cancel {{title}} plan?",
  "TV_CONNECT/CONNECTION/FAILED": "Failed to connect",
  "TV_CONNECT/DISCOVERY/NOTE": "Your TV not showing up? Make sure it's on the same network as your phone. Only Apple TV, Android TV, LG TV, and Samsung TV are supported.",
  "TV_CONNECT/DISCOVERY/SEARCHING": "Searching…",
  "TV_CONNECT/DISCOVERY/DISCONNECT": "Disconnect",
  "TV_CONNECT/DISCOVERY/DISCONNECT_CONFIRM": "Disconnect from {{name}}?",
  "TV_CONNECT/STATUS/CONNECTED": "Connected",
  "TV_REMOTE/TITLE": "TV Remote",
  "TV_REMOTE/OK": "OK",
  "TV_REMOTE/BACK": "Back",
  "TV_REMOTE/NAVIGATE": "Navigate {{direction}}",
  "TV_REMOTE/PLAY": "Play",
  "TV_REMOTE/PAUSE": "Pause",
  "TV_REMOTE/STOP": "Stop",
  "TV_REMOTE/SEEK_BACK": "Seek back 30 seconds",
  "TV_REMOTE/SEEK_FORWARD": "Seek forward 30 seconds",
  "TV_REMOTE/AD": "Ad",
  "TV_REMOTE/ADVERTISEMENT": "Advertisement {{current}} of {{total}} ({{time}})",
  "TV_REMOTE/ADVERTISEMENT_SINGLE": "Advertisement ({{time}})",
  "TV_REMOTE/ROUTE/HOME": "Home",
  "TV_REMOTE/ROUTE/SEARCH": "Search",
  "TV_REMOTE/PLAYING_ON_TV": "Playing on {{name}}",
  "TV_CONNECT/PAIR/CONNECT": "Connect",
  "TV_CONNECT/PAIR/DESCRIPTION": "A TV nearby is asking to pair. Would you like to connect it to your account?",
  "TV_CONNECT/PAIR/MODAL_TITLE": "Pair with TV?",
  "TV_CONNECT/PAIR/NOT_NOW": "Not now",
  "TV_CONNECT/HOST/CONNECTED": "Device connected",
  "TV_CONNECT/HOST/CONNECTED_NAMED": "{{name}} connected",
  "TV_CONNECT/HOST/ALLOW": "Allow",
  "TV_CONNECT/HOST/CONFIRM_DESCRIPTION": "A phone wants to connect as a remote.",
  "TV_CONNECT/HOST/CONFIRM_TITLE": "Allow remote connection?",
  "TV_CONNECT/HOST/DENY": "Deny",
  "TV_CONNECT/TITLE": "Connect to your TV",
  "WATCHLIST_PAGE/AUTH_REQUIRED_CTA_LABEL": "Sign in",
  "WATCHLIST/ADDED": "Added to Watchlist",
  "WATCHLIST/EMPTY/SUBTITLE": "Add items to your watchlist to get started",
  "WATCHLIST/EMPTY/TITLE": "Nothing here yet",
  "WATCHLIST/REMOVED": "Removed from Watchlist",
  "WATCHLIST/TITLE": "Watchlist",
} as const;

export default TRANSLATIONS;
